import { __extends } from "tslib";
import React from 'react';
import { PureComponent } from 'react';
import { Input } from './styles';
import { browser } from '@atlaskit/editor-common';
var KeyZCode = 90;
var KeyYCode = 89;
var PanelTextInput = /** @class */ (function (_super) {
    __extends(PanelTextInput, _super);
    function PanelTextInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseDown = function () {
            var onMouseDown = _this.props.onMouseDown;
            if (onMouseDown) {
                onMouseDown();
            }
        };
        _this.onBlur = function (e) {
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                onBlur(e);
            }
        };
        _this.handleChange = function () {
            var onChange = _this.props.onChange;
            if (_this.input) {
                _this.setState({
                    value: _this.input.value,
                });
            }
            if (onChange && _this.input) {
                onChange(_this.input.value);
            }
        };
        _this.handleKeydown = function (e) {
            var _a = _this.props, onUndo = _a.onUndo, onRedo = _a.onRedo, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                onSubmit(_this.input.value);
            }
            else if (e.keyCode === 27 && onCancel) {
                onCancel(e);
            }
            else if (typeof onUndo === 'function' && _this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            }
            else if (typeof onRedo === 'function' && _this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.handleRef = function (input) {
            if (input instanceof HTMLInputElement) {
                _this.input = input;
                if (_this.props.autoFocus) {
                    // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                    _this.focusTimeoutId = window.setTimeout(function () { return _this.focus(); });
                }
            }
            else {
                _this.input = undefined;
            }
        };
        _this.state = {
            value: props.defaultValue || '',
        };
        return _this;
    }
    PanelTextInput.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                value: nextProps.defaultValue,
            });
        }
    };
    PanelTextInput.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.focusTimeoutId);
    };
    PanelTextInput.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, width = _a.width, maxLength = _a.maxLength, testId = _a.testId, ariaLabel = _a.ariaLabel;
        var value = this.state.value;
        return (React.createElement(Input, { "data-testid": testId || '', type: "text", placeholder: placeholder, value: value, onChange: this.handleChange, onKeyDown: this.handleKeydown, onMouseDown: this.onMouseDown, onBlur: this.onBlur, innerRef: this.handleRef, width: width, maxLength: maxLength, "aria-label": ariaLabel }));
    };
    PanelTextInput.prototype.focus = function () {
        var input = this.input;
        if (input) {
            var focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    };
    PanelTextInput.prototype.isUndoEvent = function (event) {
        return (event.keyCode === KeyZCode &&
            // cmd + z for mac
            ((browser.mac && event.metaKey && !event.shiftKey) ||
                // ctrl + z for non-mac
                (!browser.mac && event.ctrlKey)));
    };
    PanelTextInput.prototype.isRedoEvent = function (event) {
        return (
        // ctrl + y for non-mac
        (!browser.mac && event.ctrlKey && event.keyCode === KeyYCode) ||
            (browser.mac &&
                event.metaKey &&
                event.shiftKey &&
                event.keyCode === KeyZCode) ||
            (event.ctrlKey && event.shiftKey && event.keyCode === KeyZCode));
    };
    return PanelTextInput;
}(PureComponent));
export default PanelTextInput;
//# sourceMappingURL=index.js.map